var _defs, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertaiIconSingleFullWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M860.5,867.56s-364.2,73.89-543.25-105.17c-179.06-179.06-105.17-543.25-105.17-543.25,0,0,364.2-73.89,543.25,105.17,179.06,179.06,105.17,543.25,105.17,543.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M626.64,710.12c-141.37,0-256.39-115.01-256.39-256.39s115.01-256.39,256.39-256.39,256.39,115.02,256.39,256.39-115.01,256.39-256.39,256.39ZM626.64,288.89c-90.89,0-164.84,73.95-164.84,164.84s73.94,164.84,164.84,164.84,164.84-73.95,164.84-164.84-73.94-164.84-164.84-164.84Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 626.64,
    cy: 453.73,
    r: 92.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaiIconSingleFullWhite);
export default __webpack_public_path__ + "static/media/alertai_icon_single_full_white.c81ac52b5b92ebd3e0092def3d03f0e9.svg";
export { ForwardRef as ReactComponent };